import { lazy } from "react";

const TaskManager = lazy(() => import("./TaskManager"));

const TaskManagerList = lazy(() => import("./TaskManagerList"));

const taskManagerRoutes = [
  {
    path: "/task-manager",
    component: TaskManager
  },
  {
    path: "/task-manager-list",
    component: TaskManagerList
  },
  
];

export default taskManagerRoutes;
